import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { RootState } from '../../../reducers';
import * as _actionsFilters from '../../../actions/filters';
import * as actions from '../../../actions/index';
import { ReactComponent as InfoIcon } from '../../../assets/icons/new/info-dark.svg';
import { createDateRange } from '../../../utils/react';
import './Step3.scss';
import 'react-date-range/dist/theme/default.css';
import 'react-date-range/dist/styles.css';
import AvailabilityCalendar from '../../../components/AvailabilityCalendar';
import BottomNavigation from '../../../components/BottomNavigation';
import * as _actionsSujet from '../../../actions/sujet';
import { SchemaPossibleBookingDates } from '@repo/legacy-commerce-api';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  intl: any;
  history: any;
  possibleBookingDates: SchemaPossibleBookingDates;
  actionsFilters: typeof _actionsFilters;
  actionsSujet: typeof _actionsSujet;
  userDataEC: PartiallyIntegratedUserDataEC;
  ui: any;
  nextStepCallback?: () => void;
  prevStepCallback?: () => void;
  isLoading?: boolean;
  isSkipNextStep?: boolean;
  isSkipBottomNavigation?: boolean;
}

const Step3 = ({
  intl,
  possibleBookingDates,
  userDataEC: { startDate, duration, ui, isAgencyJourney, agencyInfoPanelVisibility, agencyData },
  actionsFilters,
  actionsSujet,
  nextStepCallback,
  prevStepCallback,
  isLoading,
  isSkipNextStep,
  isSkipBottomNavigation,
}: Props) => {
  const [dateRange, setDateRange] = React.useState([]);

  useEffect(() => {
    const newDuration = duration || 7;
    let targetStartDate =
      startDate || (possibleBookingDates && possibleBookingDates.start && possibleBookingDates.start.date) || null;
    const range = createDateRange(new Date(targetStartDate), newDuration, {
      toEndOfYear: newDuration > 21,
      fullWeeks: true,
    });
    setDateRange([range]);
    actionsFilters.updateStartDate([targetStartDate, newDuration]);
    actionsFilters.updateDuration(newDuration);
  }, [possibleBookingDates]);

  const handleDateChange = (newRange, newDuration) => {
    let fullRange = [newRange];
    if (possibleBookingDates && possibleBookingDates.start && possibleBookingDates.daybeforestarttraffic) {
      const endTrafficDate = new Date(possibleBookingDates.daybeforestarttraffic.date).getTime();
      const startTrafficDate = new Date(possibleBookingDates.start.date).getTime();
      const redZoneDuration = (endTrafficDate - startTrafficDate) / (1000 * 3600 * 24);
      const trafficRange = createDateRange(startTrafficDate, redZoneDuration, {
        toEndOfYear: newDuration > 21,
        fullWeeks: true,
        key: 'traffic',
      });
      fullRange = [...fullRange, trafficRange];
    }

    setDateRange(fullRange);
    actionsFilters.updateStartDate([newRange.startDate, newDuration]);
    actionsFilters.updateDuration(newDuration);
  };

  return (
    <>
      <h4 className=' font-24'>
        <FormattedMessage id='ec.journey02.chooseDate' defaultMessage='Wie lange möchten Sie werben?' />
      </h4>
      <p className='mt-3 mb-48'>
        <FormattedMessage
          id='ec.journey02.chooseDateSecondHeader'
          defaultMessage='Wählen Sie die Anzahl Wochen und klicken Sie dann auf ein Startdatum im Kalender. Oder markieren Sie direkt mit gedrückter Maustaste den Zeitraum (Tage/Wochen) direkt im Kalender.'
        />
      </p>
      <AvailabilityCalendar
        availabilities={[]}
        possibleBookingDates={possibleBookingDates}
        dateRange={dateRange}
        duration={duration}
        intl={intl}
        isMobile={ui.isMobile}
        isAnalogProduct={true}
        dateChangeCallback={handleDateChange}
        initStep={true}
      />
      <div className='legend'>
        <div className='font-14 p-4 mb-24 bg-grey-light-anthrazit01 d-flex align-items-center'>
          <InfoIcon
            style={{
              width: '14px',
              minWidth: '14px',
              marginLeft: '5px',
              marginTop: '-2px',
            }}
            className='notice'
          />
          <div className={'ms-3'}>
            <b>
              <FormattedMessage id='ec.journey2.legendTextCalendarImportant' defaultMessage='WICHTIG:' />
            </b>
            <br />
            <FormattedMessage
              id='ec.journey2.legendTextCalendarAdvertising'
              defaultMessage='APG|SGA produziert keine Werbemittel sondern vermietet lediglich die gewünschten Werbeflächen. '
            />
            <FormattedMessage
              id='ec.journey2.legendTextCalendar'
              defaultMessage='Plakate und Verkehrsmittelwerbung müssen jeweils 10 Arbeitstage vor Aushang an die Logistik geliefert werden. Anlieferdatum/-adresse und mögliche Produktionspartner für Ihre Plakate/Spots erfahren Sie am Schluss Ihrer Buchung.'
            />
            <br />
            <br />
            <FormattedMessage
              id='ec.journey2.legendTextCalendar2'
              defaultMessage='Für digitale Produkte können Sie später noch individuell den Wochentag und die Dauer wählen, sowie ein früheres Startdatum festlegen.'
            />
          </div>
        </div>
      </div>
      {isSkipBottomNavigation ? null : (
        <BottomNavigation
          nextCallback={nextStepCallback}
          prevCallback={prevStepCallback}
          isLoading={isLoading}
          isSkipNextStep={isSkipNextStep}
          isAgencyJourney={isAgencyJourney}
          agencyData={agencyData}
          changeAgencyInfoPanelVisibility={(value) => {
            actionsSujet.setAgencyInfoPanelVisibility(value);
          }}
          agencyInfoPanelVisibility={agencyInfoPanelVisibility}
        />
      )}
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    dispatch: dispatch,
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
    actionsSujet: bindActionCreators(_actionsSujet, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Step3)));
